import Immutable from 'immutable'
import { declareResourceType } from '@rwwa/rwwa-data-access'
import { TypedRecord, makeTypedFactory } from 'typed-immutable-record'
import { fetchData } from '../helpers'

export interface IQuaddie {
  key: string
  confidence: number
  comment: string
  updatedAt: Date
  outlay: string
  valueOutlay: string
  legs: Immutable.List<IQuaddieLegRecord>
}

const defaultQuaddie: IQuaddie = {
  key: '',
  confidence: 0,
  comment: '',
  updatedAt: new Date(),
  outlay: '',
  valueOutlay: '',
  legs: Immutable.List<IQuaddieLegRecord>(),
}

export interface IQuaddieLeg {
  raceKey: string
  raceNumber: number
  comment: string
  selections: string
  valueSelections: string
}

const defaultLeg: IQuaddieLeg = {
  raceKey: '',
  raceNumber: 0,
  comment: '',
  selections: '',
  valueSelections: '',
}

export interface IQuaddieRecord extends TypedRecord<IQuaddieRecord>, IQuaddie {}
const QuaddieRecordFactory = makeTypedFactory<IQuaddie, IQuaddieRecord>(defaultQuaddie)

export interface IQuaddieLegRecord extends TypedRecord<IQuaddieLegRecord>, IQuaddieLeg {}
const LegRecordFactory = makeTypedFactory<IQuaddieLeg, IQuaddieLegRecord>(defaultLeg)

export const GiddyUpQuaddieTips = declareResourceType<IQuaddieRecord, IQuaddieRecord>({
  typeKey: 'giddyUpQuaddieTips',
  map: convertQuaddieTipToImmutable,
  fetchSingle: getQuaddieTips,
  maxToKeep: 1,
})

// Bit of a hack here - we pretend that the fixture is the quaddie
function getQuaddieTips(fixtureKey: string) {
  return fetchData(`fixture?key=${fixtureKey}`).then(response => {
    // @ts-expect-error API contract not typed
    const key = response.sortedQuaddieKeys[0] || ''
    // @ts-expect-error API contract not typed
    const quaddie = response.giddyUpQuaddies[key]
    if (isQuaddieTipsValid(quaddie)) {
      return { giddyUpQuaddieTips: { [fixtureKey]: quaddie } }
    } else {
      throw 'Not Found'
    }
  })
}

function convertQuaddieTipToImmutable(mutableQuaddie: IQuaddie): IQuaddieRecord {
  const legs = Immutable.List<IQuaddieLegRecord>(
    mutableQuaddie.legs.map(leg => LegRecordFactory(leg))
  )
  mutableQuaddie.legs = legs
  const quaddie = QuaddieRecordFactory(mutableQuaddie)
  return quaddie
}

function isQuaddieTipsValid(quaddie: IQuaddie) {
  // A couple of checks as there have been occasions of missing data
  if (
    !quaddie ||
    !quaddie.outlay ||
    // @ts-expect-error typing issue tbd later
    !quaddie.legs[0].selections
  )
    return false

  return true
}
